import { Dispatch } from 'redux';
import { GetMaintDelays } from '../../services/DelayListService/DelayListService';
import { DelayCollectionModel } from '../../Model/DelayListCollection';

// Action Types
export const FETCH_MAINT_DELAYS_REQUEST = 'FETCH_MAINT_DELAYS_REQUEST';
export const FETCH_MAINT_DELAYS_SUCCESS = 'FETCH_MAINT_DELAYS_SUCCESS';
export const FETCH_MAINT_DELAYS_FAILURE = 'FETCH_MAINT_DELAYS_FAILURE';
export const ADD_MAINT_DELAY = "ADD_MAINT_DELAY";
export const UPDATE_MAINT_LIST = "UPDATE_MAINT_LIST";
export const DELETE_MAINT_DELAY = "DELETE_MAINT_DELAY";

// Action Creator
export const fetchMaintDelays = (token: string, station: string, delayCode: string, flightDate: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: FETCH_MAINT_DELAYS_REQUEST });
    
    try {
      const maintlist = await GetMaintDelays(token, station, delayCode, flightDate);
      dispatch({
        type: FETCH_MAINT_DELAYS_SUCCESS,
        payload: maintlist
      });
    } catch (error:any) {
      dispatch({
        type: FETCH_MAINT_DELAYS_FAILURE,
        payload: error.message
      });
    }
  };
};

export const addMaintDelay = (savedRecord: DelayCollectionModel) => {
  return {
    type: ADD_MAINT_DELAY,
    payload: savedRecord,
  };
};

export const updateMaintList = (updatedList: DelayCollectionModel[]) => {
  return {
    type: UPDATE_MAINT_LIST,
    payload: updatedList,
  };
};

export const deleteMaintDelay = (maintDncId: string) => {
  return {
    type: DELETE_MAINT_DELAY,
    payload: maintDncId,
  };
};


